/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Uploader_FailedInputs */

const en_common_uploader_failed = /** @type {(inputs: Common_Uploader_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed`)
};

const zh_common_uploader_failed = /** @type {(inputs: Common_Uploader_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`失败`)
};

/**
* | output |
* | --- |
* | "Failed" |
*
* @param {Common_Uploader_FailedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_uploader_failed = /** @type {((inputs?: Common_Uploader_FailedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Uploader_FailedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_uploader_failed(inputs)
	return zh_common_uploader_failed(inputs)
});
export { common_uploader_failed as "common.uploader.failed" }